import { render, staticRenderFns } from "./roster.vue?vue&type=template&id=697ac36f&scoped=true"
import script from "./roster.vue?vue&type=script&lang=js"
export * from "./roster.vue?vue&type=script&lang=js"
import style0 from "./roster.vue?vue&type=style&index=0&id=697ac36f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697ac36f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('697ac36f')) {
      api.createRecord('697ac36f', component.options)
    } else {
      api.reload('697ac36f', component.options)
    }
    module.hot.accept("./roster.vue?vue&type=template&id=697ac36f&scoped=true", function () {
      api.rerender('697ac36f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/staffManagement/roster/roster.vue"
export default component.exports